import { useCallback, useEffect, useRef } from 'react';

// Custom hook for sticky header functionality based on Medium article solution
export const useStickyTableHeader = () => {
  const tableWrapperRef = useRef<HTMLDivElement>(null);
  const tableHeaderRef = useRef<HTMLTableSectionElement>(null);

  const handleScroll = useCallback(() => {
    if (!tableWrapperRef.current || !tableHeaderRef.current) return;

    const tableWrapper = tableWrapperRef.current;
    const tableHeader = tableHeaderRef.current;

    // Find the Jobs page main scrolling container by traversing up
    let scrollingElement: HTMLElement | null = null;
    let parent = tableWrapper.parentElement;

    while (parent) {
      const styles = window.getComputedStyle(parent);
      // Look for the main page container that has overflow-y auto
      if (styles.overflowY === 'auto' || styles.overflow === 'auto') {
        scrollingElement = parent;
        break;
      }
      parent = parent.parentElement;
    }

    if (!scrollingElement) return;

    const scrollTop = scrollingElement.scrollTop;
    const tableWrapperTop = tableWrapper.offsetTop;

    // Check if user has scrolled past the table start position
    if (scrollTop > tableWrapperTop) {
      // Translate the header by the scroll difference to keep it at the top
      const translateY = scrollTop - tableWrapperTop;
      tableHeader.style.transform = `translateY(${translateY - 2}px)`;
    } else {
      // Reset translation when not scrolled past header
      tableHeader.style.transform = 'translateY(0px)';
    }
  }, []);

  useEffect(() => {
    if (!tableWrapperRef.current) return;

    // Find the Jobs page main scrolling container by traversing up
    let scrollingElement: HTMLElement | null = null;
    let parent = tableWrapperRef.current.parentElement;

    while (parent) {
      const styles = window.getComputedStyle(parent);
      // Look for the main page container that has overflow-y auto
      if (styles.overflowY === 'auto' || styles.overflow === 'auto') {
        scrollingElement = parent;
        break;
      }
      parent = parent.parentElement;
    }

    if (!scrollingElement) return;

    scrollingElement.addEventListener('scroll', handleScroll);

    return () => {
      scrollingElement.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  return { tableWrapperRef, tableHeaderRef };
};
